import { environment } from "../../environments/environment";

export const ROLES: string[] = [
  'Educator / Academic Admin',
  'Corporate L&D / Training Head',
  'Government / Educational Organization',
  'Student / Job Seeker',
  'General User',
  'Other'
];
export const SUPPORT_EMAILS = environment.SUPPORT_EMAILS;

export const APP_CONSTANTS = environment.APP_CONSTANTS;
export const YOUTUBE_URL = (environment as any).YOUTUBE_URL || '';
